.indicator {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin: 1rem 0;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
}

.title {
  margin: 0;
  font-size: 1.125rem;
}

.line {
  margin: 0;
}

.name {
  font-weight: 600;
}

.refusal {
  margin: 0;
  font-weight: 600;
  color: var(--danger-text);
}

.trace {
  margin: 0;
  padding-left: 1.25rem;
}
